import App from './App.vue'
import vuetify from './vuetify'
import anketa from './mixins/anketa'
import connector from "./mixins/connector";
import forms from "./mixins/forms";
import modals from "./mixins/modals";
import locale from "@/mixins/locale";

import './assets/opensans/opensans.css';

import Field from "./components/Field";
import Cards from "./components/controls/Cards";
import Button from "./components/controls/Button";
import BaseForm from "./components/controls/BaseForm";


// миксин для $root 
let widget = {
  mounted() {
    this.$nextTick(() => {
      
    })
  },
  computed: {
    sumGoods() {
      let goods = this.CLObject.goods || [];
      let sumGoods = 0;

      goods.forEach((good) => {
          sumGoods = sumGoods + good.Price * good.Count;
      });

      return sumGoods;
    },
  },
  watch: {
    
  },
  data: () => ({  }),
  methods: {
 
  }
};


export default {
  App,
  vuetify,
  mixins: [
    widget, 
    anketa, 
    forms, 
    modals, 
    connector, 
    locale
  ],
  install: (Vue) => {
    Vue.prototype.$widgetType = "zaymer";

    Vue.component('Field', Field);
    Vue.component('Button', Button);
    Vue.component('Cards', Cards);
    Vue.component('BaseForm', BaseForm);

    // Vue.component('PaylateLogo', PaylateLogo);

    // делаем доступными во всех компонентах
    Vue.mixin({
      computed: { 
          $sumGoods() {
            return this.$root.sumGoods;
          },          
      },
      methods: {
        // метод $t (translate) из миксина locale
        $t(message, props) {
          return this.$root.locale.translate(message, props);
        },
      },
    });
  },
};
